var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "15px",
    viewBox: "0 0 17 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "589855CF-0305-4A25-B00B-E5DAFD1AB35C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 121818,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visit-Card-States",
    transform: "translate(-91.000000, -283.000000)",
    fill: "#F5AD0D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visit-Card-/-Upcoming",
    transform: "translate(15.000000, 163.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "What-to-expect"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.8549833,26.166352 C80.5261263,25.6066826 73.8852952,14.4210409 73.3171665,13.4662455 C72.9438949,12.8394305 72.0544692,12.8497606 71.6808197,13.4662455 C71.2642676,14.1535654 64.5896057,25.3818187 64.125804,26.1949442 C63.7857962,26.7904001 64.1613357,27.5714286 64.9350945,27.5714286 L80.0409679,27.5714286 C80.7434743,27.5714286 81.2658655,26.8647398 80.8549833,26.166352 Z M72.5,26.3571429 C71.9971036,26.3571429 71.5892857,25.9495071 71.5892857,25.4464286 C71.5892857,24.94335 71.9971036,24.5357143 72.5,24.5357143 C73.0030786,24.5357143 73.4107143,24.94335 73.4107143,25.4464286 C73.4107143,25.9495071 73.0030786,26.3571429 72.5,26.3571429 Z M73.1071429,23.3533835 C73.1071429,23.7368421 72.9047619,23.9285714 72.5,23.9285714 C72.0952381,23.9285714 71.8928571,23.7368421 71.8928571,23.3533835 L71.2857143,17.7932331 C71.2857143,17.2180451 71.6904762,16.6428571 72.5,16.6428571 C73.3095238,16.6428571 73.7142857,17.2180451 73.7142857,17.7932331 L73.1071429,23.3533835 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertYellow);
export default __webpack_public_path__ + "static/media/alert-yellow.562c2a92c0d9076728a92164fa930dee.svg";
export { ForwardRef as ReactComponent };